//#region import
import React, { Fragment, createContext, useContext, useEffect, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { DefaultArrayEmpty, FnAxios, FnDialog, I18n, IsNullOrUndefined, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnDraft, BtnEdit, BtnSave, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import AccordionPanel from '../components/AccordionPanel';
import { TextAreaItem } from 'components/Input/TextArea';
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import { useLocation } from 'react-router';
//#endregion

const Panel11 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [nProjectIssueIDEdit, setnProjectIssueIDEdit] = useState(0);
    const [ObjIssueIDEdit, setObjIssueIDEdit] = useState(null);
    const [arrProjectIssue, setarrProjectIssue] = useState([]);
    const [DataRowIssue, setDataRowIssue] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sIssue: null,
            sSolution: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel11, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            
            setarrProjectIssue(result.objResult.lstProjectIssue);
            setDataRowIssue({
                ...initRows,
                nDataLength: result.objResult.lstProjectIssue.length,
                arrRows: result.objResult.lstProjectIssue,
            });
        });
    };

    const dataColumnIssue: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Issue_" + item.row.sID}
                                id={"btnDelete_Issue_" + item.row.sID}
                                onClick={() => onDeleteIssue(item.row.nID, EnumStatusMode.Delete)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Issue_" + item.row.sID}
                                id="btnEdit"
                                onClick={() => onEditIssue(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Issue_" + item.row.sID}
                            id="btnView"
                            onClick={() => onEditIssue(item.row, EnumStatusMode.View)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nNo",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sIssue",
            headerName: "ปัญหา/อุปสรรค",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 4,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },      
        {
            field: "sSolution",
            headerName: "แนวทางการแก้ไขปัญหา/อุปสรรค",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 4,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },       
    ];

    const onAddIssue = () => {
        let oForm = form.getValues();
        let ObjDuplicate = arrProjectIssue.filter((f) => !f.isDelete && (nProjectIssueIDEdit !== 0 ? f.nID !== nProjectIssueIDEdit : true) && f.sIssue === oForm.sIssue && f.sSolution === oForm.sSolution);
        if ((ObjDuplicate || []).length === 0)
        {   
            //#region Old
            // let nProjectIssueID = 0;
            // let dataRow = DataRowIssue;
            // let arrIssue = DefaultArrayEmpty(arrProjectIssue);
            // let nMaxID = new LINQ<any>(arrIssue).Any() ? new LINQ<any>(arrIssue).Max((m) => m.nID) + 1 : 1;
            // if (nProjectIssueIDEdit) {
            //     arrIssue = arrIssue.filter((f) => f.nID !== nProjectIssueIDEdit);
            //     nProjectIssueID = arrProjectIssue.find((f) => f.nID === nProjectIssueIDEdit)?.nProjectIssueID;
            //     nMaxID = nProjectIssueIDEdit;
            // }
            // let obj = {
            //     isDelete: false,
            //     isEdit: false, 
            //     sID: nMaxID.toString(),
            //     nNo: nMaxID,
            //     nID: nMaxID,
            //     nProjectIssueID: nProjectIssueID,
            //     sIssue: oForm.sIssue,
            //     sSolution: oForm.sSolution,    
            // };

            // let nNo = 1;
            // let result = [...arrIssue, obj];
            // result.forEach(f => {
            //     if (f.isDelete === true) {
            //         f.nNo = 0;
            //     } else {
            //         f.nNo = nNo++;
            //     }
            // });
            // let arrTable = result.filter(f => !f.isDelete);
            // setDataRowIssue({
            //     ...dataRow,
            //     nDataLength: arrTable.length,
            //     arrRows: arrTable,
            // });
            // setnProjectIssueIDEdit(0);
            // setObjIssueIDEdit(null);
            // setarrProjectIssue(result);
            // onClearFieldIssue();
            //#endregion
        
            //#region New
            let nProjectIssueID = 0;
            let dataRow = DataRowIssue;
            let arrIssue = DefaultArrayEmpty(arrProjectIssue);

            if (nProjectIssueIDEdit) //Edit
            {
                const oEditIndex = arrIssue.findIndex((item) => item.nID === nProjectIssueIDEdit);
                if (oEditIndex !== -1) {
                    arrIssue[oEditIndex].sIssue = oForm.sIssue;
                    arrIssue[oEditIndex].sSolution = oForm.sSolution;
                }
                let arrTable = arrIssue.filter(f => !f.isDelete);
                setDataRowIssue({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
            } 
            else //Add
            {            
                let nMaxID = new LINQ<any>(arrIssue).Any() ? new LINQ<any>(arrIssue).Max((m) => m.nID) + 1 : 1;            
                let obj = {
                    isDelete: false,
                    isEdit: false, 
                    sID: nMaxID.toString(),
                    nNo: nMaxID,
                    nID: nMaxID,
                    nProjectIssueID: nProjectIssueID,
                    sIssue: oForm.sIssue,
                    sSolution: oForm.sSolution,    
                };

                let nNo = 1;
                let result = [...arrIssue, obj];
                result.forEach(f => {
                    if (f.isDelete === true) {
                        f.nNo = 0;
                    } else {
                        f.nNo = nNo++;
                    }
                });
                let arrTable = result.filter(f => !f.isDelete);
                setDataRowIssue({
                    ...dataRow,
                    nDataLength: arrTable.length,
                    arrRows: arrTable,
                });
                setarrProjectIssue(result);
            }
            setnProjectIssueIDEdit(0);
            setObjIssueIDEdit(null);
            onClearFieldIssue();
            //#endregion
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearFieldIssue = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
    };

    const onEditIssue = (ObjData, nModeID : EnumStatusMode) => {
        setnProjectIssueIDEdit(ObjData.nID);   
        let ObjIssue = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nNo,
            nID: ObjData.nID,
            nProjectIssueID: ObjData.nProjectIssueID,
            sIssue: ObjData.sIssue,
            sSolution: ObjData.sSolution,             
        };
        setObjIssueIDEdit(ObjIssue);
        form.setValue("sIssue", ObjIssue.sIssue);
        form.setValue("sSolution", ObjIssue.sSolution);

        document.getElementById("myDivIssue").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteIssue = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrIssueData: any[] = arrProjectIssue;
            let result = arrIssueData.filter((f) => f.nID !== nID);
            let arrDelete = arrIssueData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nNo = 0;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowIssue({
                ...DataRowIssue,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectIssue([...result, ...arrDelete]);
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (arrProjectIssue.filter(f => !f.isDelete).length === 0 && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ");
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel11,
            isFastTrack: isFastTrack,

            lstProjectIssue: arrProjectIssue ?? [],

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel11, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 11, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"11. ปัญหา/อุปสรรคที่คาดว่าจะเกิดขึ้นระหว่างดำเนินการและแนวทางการแก้ไข"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >
            <Grid id={"myDivIssue"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item>
                                <Typography variant='h6' color={'#0000a5'}>ปัญหา/อุปสรรคที่คาดว่าจะเกิดขึ้นระหว่างดำเนินการและแนวทางการแก้ไข</Typography>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider />
                            </Grid>
                        </Grid>                                        
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sIssue"}
                                name={"sIssue"}
                                label={"ปัญหา/อุปสรรค"}             
                                placeholder={"ระบุปัญหา/อุปสรรคที่คาดว่าจะเกิดขึ้นระหว่างดําเนินโครงการและ/หรือภายหลังดําเนินโครงการเสร็จสิ้นเรียบร้อยแล้ว"}                 
                                required={true}
                                maxLength={500}
                                row={3}
                                disabled={!isPermission || isEditSecretary === false}
                            />
                        </Grid> 
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sSolution"}
                                name={"sSolution"}
                                label={"แนวทางการแก้ไขปัญหา/อุปสรรค"}
                                placeholder={"ระบุแนวทางการแก้ไขปัญหา/อุปสรรคในเบื้องต้น"}
                                required={true}
                                maxLength={500}
                                row={3}
                                disabled={!isPermission || isEditSecretary === false}
                            />
                        </Grid>   
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                            {(nProjectIssueIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                <BtnAdd id={"btnAdd_Table_Issue"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่ม"} onClick={form.handleSubmit((e) => onAddIssue(),(err) => console.log("err", err))} />
                                :
                                <>
                                    {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                        <Grid item>
                                            <BtnSave id={"btnSave_Table_Issue"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => onAddIssue(),(err) => console.log("err", err))} />
                                        </Grid>
                                    }
                                    {nProjectIssueIDEdit !== 0 &&
                                        <Grid item>
                                            <BtnCancel id={"btnCancel_Table_Issue"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnProjectIssueIDEdit(0); setObjIssueIDEdit(null); onClearFieldIssue(); }} />
                                        </Grid>
                                    }         
                                </>
                            }
                            {/* <BtnAdd 
                                id={"btnAdd"} 
                                txt={nProjectIssueIDEdit === 0 ? "เพิ่ม" : "บันทึก"} 
                                sColor={nProjectIssueIDEdit === 0 ? null : "#3cbd2a"}
                                sColorHover={nProjectIssueIDEdit === 0 ? null : "#4eb540"}
                                // sFontColor={"#ffffff"}
                                onClick={form.handleSubmit((e) => onAddIssue(),(err) => console.log("err", err))}
                            /> */}
                        </Grid>
                        <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                            <DataGrid
                                sTableID='TB_ProjectIssue'
                                columns={dataColumnIssue}
                                rows={DataRowIssue}
                                isShowColomnTool={false}
                                isHiddenToolHead={true}
                                isShowCheckBox={false}
                                isHiddenPagination={false}
                            />
                        </Grid>
                        {nProjectID === 0 || nStatusID === EnumProjectStatusID.nStatusID_11 ?
                            <></>
                            :
                            (isPermission === true &&
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                <BtnDraft id={"btnDraft_Panel11"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                            </Grid>
                                        }
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel11"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit) }} />
                                        </Grid> 
                                    </Grid>    
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel11"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivIssue").scrollIntoView({ behavior: "smooth" }); }} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel11"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel11"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }       
                    </Grid>                       
                </FormProvider>
            </Grid>
        </AccordionPanel>
    )
}
export default Panel11;
